import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import LeftInput from "./editComponents/LeftInput";
import RightInput from "./editComponents/RightInput";
import { getARestaurantOrderAction } from "../../../../redux/restaurantOrder/restaurantOrderActions";

export default function EditRestaurantOrder() {
  const dispatch = useDispatch();
  const {id} = useParams();

  const [submitted, setSubmitted] = useState(false);
  const { order } = useSelector((state) => state.restaurantOrder);
  

  let [recipient_phone, setRecipientPhone] = useState("");
  
  const [data, setData] = useState({
    id:'',
    business_id: "",
    user_address_id: "1",
    user_id: "",
    restaurant_id: "",
    recipient_name: "",
    recipient_email: "",
    recipient_phone: "",
    recipient_address: "",
    recipient_city: "",
    recipient_state: "",
    recipient_country: "",
    order_type: "standard",
    order_paid: "",
    order_payment_method: "",
    order_items: [],
    order_amount: "",
    order_discount: 0,
    order_sub_amount:0,
    recipient_service_area_id: "",
  });

  useEffect(() => {
    if (id) {
      dispatch(getARestaurantOrderAction(id));
    }
    // eslint-disable-next-line
  }, [id]);


  useEffect(() => {
    if (order) {
      setData({
        ...data,
        id: order?.id,
        business_id: order?.business_id,
        restaurant_id: order?.restaurant_id,
        recipient_name: order?.recipient_name,
        recipient_email: order?.recipient_email,
        recipient_phone: order?.recipient_phone,
        recipient_address: order?.recipient_address,
        recipient_city: order?.recipient_city,
        recipient_state: order?.recipient_state,
        recipient_country: order?.recipient_country,
        order_type: order?.order_type,
        order_paid: order?.order_paid,
        order_payment_method: order?.order_payment_method,
        order_items: order?.order_items,
        order_amount: order?.order_amount,
        order_discount: order?.order_discount,
        order_sub_amount: order?.order_sub_amount,
        recipient_service_area_id: order?.recipient_service_area_id,
      });
      setRecipientPhone(order?.recipient_phone);
    }
    // eslint-disable-next-line
  }, [order]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setData({ ...data, [name]: value });
  };
  return (
    <div data-test="createOrder-page">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="border border-[#E4E4F3] bg-white sm:h-[786px] rounded-md py-5 px-8">
          <LeftInput
            handleChange={handleChange}
            data={data}
            setData={setData}
            submitted={submitted}
            recipient_phone={recipient_phone}
            setRecipientPhone={setRecipientPhone}
          />
        </div>

        <RightInput
          data={data}
          setData={setData}
          submitted={submitted}
          setSubmitted={setSubmitted}
          handleChange={handleChange}
          recipient_phone={recipient_phone}
        />
      </div>
    </div>
  );
}
